export const urlIsAbsolute = (url: string): boolean => {
    return url.startsWith("http://") || url.startsWith("https://");
};
